import React, { createContext, useContext, useEffect } from "react";
import DonorLogo from "../assets/image/DONOR_LOGO.svg";
import CustomerLogo from "../assets/image/CMS_LOGO.svg";
import donorImage from "../assets/image/donor-login-image.png";
import customerImage from "../assets/image/login-image.png";
import DynamicFavicon from "../components/DynamicFavicon/DynamicFavicon";
import { updatePageContent } from "../utils/pageTitle";

const UserTypeContext = createContext();

export const useUserType = () => useContext(UserTypeContext);

export const UserTypeProvider = ({ children }) => {
  const hostname = window?.location?.hostname;
  
  const isDonor = hostname.includes("clouddonormanager");
  
  const userType = isDonor ? "donor" : "customer";
  
  useEffect(() => {
    updatePageContent(userType);
  }, [userType]);

  const value = {
    userType: userType,
    logo: isDonor ? DonorLogo : CustomerLogo,
    loginImage: isDonor ? donorImage : customerImage,
    isDonor: isDonor,
    hostname: hostname,
  };

  return (
    <UserTypeContext.Provider value={value}>
      <DynamicFavicon isDonationMode={isDonor} />
      {children}
    </UserTypeContext.Provider>
  );
};
